// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83c01d92","501":"b330caad"}[chunkId] + ".chunk.js";
};